import { get } from 'svelte/store';
import { store } from '$lib/utilities/store.js';
import { formUpdate } from "$lib/sections/Admin/formUpdate";

export const detectFieldAction = (key, sampleValue, col, docId) => {
	let settingUpdateTimeout;
	let loading;
	const settingUpdate = (event) => {
		if (settingUpdateTimeout) clearTimeout(settingUpdateTimeout);
		settingUpdateTimeout = setTimeout(async () => {
			const currentStore = get(store);
			await formUpdate(event, currentStore, loading, col, docId);
		}, 1000);
	};
	if (typeof sampleValue?.value !== 'undefined') return settingUpdate;
};
export const detectFieldType = (key, sampleValue) => {
	if (typeof sampleValue?.value !== 'undefined') return 'SettingFormInput';
	const declaredType = (
		getSampleTypeName(sampleValue) || ""
	).toLowerCase();
	if (declaredType.includes("image")) {
		return "Image";
	}
	if (
		["file", "files", "document", "template", "signature"].some(
			(token) => declaredType.includes(token),
		)
	) {
		return "file";
	}
	if (declaredType === "textobject") {
		return "TextObject";
	}
	if (
		looksLikeImage(sampleValue) ||
		`${key}`.toLowerCase().includes("image")
	) {
		return "Image";
	}
	if (looksLikeFileCollection(sampleValue)) {
		return "file";
	}
	if ((sampleValue?.type || "").toLowerCase() === "textobject") {
		return "TextObject";
	}
	if (looksLikeObject(sampleValue)) {
		return "TextObject";
	}
	return undefined;
};

const getSampleTypeName = (value) => {
	if (!value || typeof value !== "object") return undefined;
	if (typeof value.type === "string") return value.type;
	if (typeof value?.value?.type === "string") return value.value.type;
	if (typeof value?.type?.value === "string") return value.type.value;
	return undefined;
};

const looksLikeImage = (value) => {
	const candidate = value?.value ?? value;
	if (!candidate || typeof candidate !== "object") return false;
	return (
		(candidate?.width || candidate?.height) &&
		(candidate?.src || candidate?.url || candidate?.path)
	);
};

const looksLikeFileCollection = (value) => {
	const candidate = value?.value ?? value;
	if (!candidate) return false;
	const entries = Array.isArray(candidate)
		? candidate
		: typeof candidate === "object"
			? Object.values(candidate)
			: [];
	return entries.some(
		(entry) =>
			entry &&
			typeof entry === "object" &&
			(typeof entry.type === "string" ||
				typeof entry.mimeType === "string"),
	);
};

const looksLikeObject = (value) => {
	const candidate = value?.value ?? value;
	if (!candidate) return false;
	return typeof candidate === "object";
};
